import { ListItem } from 'components/Autocomplete';
import styled from 'styled-components';
import { textTruncate } from 'styles/sharedStyle';
import { convertValueToContained } from 'utils/common.utils';
import type { AutocompleteRenderOptionState } from '@material-ui/core/Autocomplete';
import type { Option } from 'components/Autocomplete/Autocomplete.config';

const QuizSearchOption = (
  props: React.HTMLAttributes<HTMLLIElement>,
  option: Option,
  { inputValue }: AutocompleteRenderOptionState
) => {
  const entries = Object.entries(option as object)?.filter(([_, val]) => {
    const optionContainedValue = convertValueToContained(val) as string;
    const inputContainedValue = convertValueToContained(inputValue) as string;

    return optionContainedValue.includes(inputContainedValue);
  })?.[0];
  return (
    <ListItem key={option?.name} tabIndex={0} {...props}>
      <div style={{ maxWidth: 100 }}>
        {entries?.[0] ? (
          <Label>
            <strong>{entries[0]}: </strong> {entries[1]}
          </Label>
        ) : (
          <Label>{option?.id}</Label>
        )}
      </div>
    </ListItem>
  );
};

export default QuizSearchOption;

const Label = styled.strong`
  ${textTruncate}
`;
